import { useTranslation } from 'react-i18next';

export function useLanguageReference() {
  let { t } = useTranslation();
  if (t('locale') !== 'fr')
    return {
      descriptionReference: 'descriptionEn',
      nameReference: 'nameEn',
      labelReference: 'labelEnglish',
      warningReference: 'warningEn',
      warningReferenceFallback: 'warningFr',

      visitDescriptionReference: 'visitDescription',
      customLabelReference: 'customLabelEnglish',
    };

  return {
    descriptionReference: 'descriptionFr',
    nameReference: 'nameFr',
    labelReference: 'labelFrench',
    warningReference: 'warningFr',
    warningReferenceFallback: 'warningEn',

    visitDescriptionReference: 'visitDescription',
    customLabelReference: 'customLabelFrench',
  };
}
